import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { GenerateCertificateService } from './generate-certificate.service';
import { fuseAnimations } from '@fuse/animations';
import { ToolbarService } from 'app/layout/components/toolbar/toolbar.service';
import { CommonService } from '@fuse/services/common.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ChooseCertificateDialogComponent } from '@fuse/Dialog/choose-certificate-dialog/choose-certificate-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CertificateTemplatesService } from '../certificate-templates/certificate-templates.service';
import { OrderService } from 'app/main/orders/order.service';
import { MatTableDataSource } from '@angular/material/table';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SuccessDialogComponent } from '@fuse/Dialog/success-dialog/success-dialog.component';
import { Router } from '@angular/router';
import { GroupsService } from 'app/main/groups/groups.service';
import { log } from 'console';

@Component({
  selector: 'app-generate-certificate',
  templateUrl: './generate-certificate.component.html',
  styleUrls: ['./generate-certificate.component.scss'],
  animations: fuseAnimations,
})
export class GenerateCertificateComponent implements OnInit, OnDestroy {
  selectedEvent;
  form: FormGroup;
  showDetails: boolean = false;
  categoriesList: string;
  allCertificate: [] = [];
  selectedTemplate;
  isTemplateChoose: boolean = false;
  selectedUsers: any[] = []
  contactGroup: any[] = []

  filtered: { pageIndex: number; pageSize: number; search: string; eventId: string; id?: number } = {
    pageIndex: 1,
    pageSize: 10,
    search: "",
    eventId: ""
  }

  filter = {
    pageIndex: 1,
    pageSize: 10,
  }

  isGetDataFromEventId: boolean = true;
  isSelectedGroupId: number = 0

  displayedColumns: string[] = ['select', 'customerName', 'email', 'mobile'];
  displayedColumnsContact: string[] = ['select', 'fullName', 'email', 'mobileNo']
  dataSource;
  userList: any[] = [];
  maxAvailableRecordsInTable;
  isIndeterminate: boolean;


  isWithoutEvent: boolean = false;
  hasSelectedUsers: boolean;
  checkboxes: any = {};

  allContactGroupList: any[] = [];
  selectedGroup = new FormControl('all');


  // Private
  private _unsubscribeAll: Subject<any>;

  constructor(
    private _fb: FormBuilder,
    public _GenerateCertificateService: GenerateCertificateService,
    private _router: Router,
    private _fuseProgressBarService: FuseProgressBarService,
    private _MatSnackBar: MatSnackBar,
    private _CertificateTemplatesService: CertificateTemplatesService,
    public _orderService: OrderService,
    private _matDialog: MatDialog,
    public _CommonService: CommonService,
    private _ToolbarService: ToolbarService,
    private _groupsService: GroupsService,
    private cdr: ChangeDetectorRef
  ) {

    this.setToolBarTitle(false);
    this.form = this.createForm();



    this.getAllCertificateList({ attachType: this.form.get('certificateType').value == "withoutEvent" ? 1 : 2 });


    this.form.get('certificateType').valueChanges.subscribe((res) => {

      this.getAllCertificateList({ attachType: res == "withoutEvent" ? 1 : 2 });
    })


  }

  createForm() {
    return this._fb.group({
      certificateType: ['withEvent'],
      selectedEvent: ['', Validators.required],
      selectedTempateId: ['', Validators.required]
    })
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource([]);

    this.form.get('certificateType').valueChanges.subscribe((res) => {
      if (res === 'withoutEvent') {
        this.isWithoutEvent = true;
        if (!this.form.get('selectedTempateId').value) {
          this.getAllCertificateList({ attachType: 1 }).then(() => {
            this.onChooseCertificate();
          });
        }
      } else {
        this.isWithoutEvent = false;
      }
    })

    this._GenerateCertificateService.getGroups({}).then((res: any) => {
      console.log("all contact groups", res);
      if (res.data.groupList.length) {
        this.allContactGroupList = res.data.groupList;
      } else {
        this.allContactGroupList = []
      }
    })
  }

  /**
    * On destroy
    */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll?.next([]);
    this._unsubscribeAll?.complete();
    this.removeSelectedUsers();
  }


  /**
   *  get selected user from localstorage
   * **/
  getSelectedUser() {
    if (localStorage.getItem('selectedAttendees') != null) {
      JSON.parse(localStorage.getItem('selectedAttendees')).map(contact => {
        this.checkboxes[contact] = true;
      });
    }
    return localStorage.getItem('selectedAttendees') == null ? [] : JSON.parse(localStorage.getItem('selectedAttendees'));
  }


  removeSelectedUsers() {
    localStorage.removeItem('selectedAttendees');
  }



  // EVENT SELECTION
  onEventSelect(value) {
    console.log("value in onEventSelect", value);
    if (value != 0) {

      this._fuseProgressBarService.show();
      this._CommonService.getEventById({ eventId: value }).then((res: any) => {
        if (res.status == 200) {
          this._fuseProgressBarService.hide();
          console.log("hello on event select", res.data);

          this.selectedEvent = res.data;
          this.showDetails = true;
          let eventCate = [];
          this.filtered.eventId = res.data.id;
          this.selectedEvent.categoriesList.forEach((item) => eventCate.push(item.title));
          this.categoriesList = eventCate.join(', ');
          // this.filterData();

        } else {
          this._fuseProgressBarService.hide();
          this._MatSnackBar.open(res.message, "OKAY", { duration: 3000 })
          this.selectedEvent = null;
          this.showDetails = false;
          this.categoriesList = '';
        }
      });
    }
  }


  onPageChange(event) {
    this.filtered.pageIndex = event.pageIndex + 1;
    this.filtered.pageSize = event.pageSize;

    if (this.isWithoutEvent) {
      this.filter.pageIndex = event.pageIndex + 1;
      this.filter.pageSize = event.pageSize;
      this.getContactMembers();
    } else {
      if (this.isGetDataFromEventId) {
        this.filterData();
      } else {
        this.onGroupSelect(this.filtered?.id);
      }
    }
  }

  setToolBarTitle(edit) {
    if (edit) {
      // for title
      this._ToolbarService._ToolBarTitle.next("Select Attendees");
      // for btn
      this._ToolbarService._isBackBtnShow.next(true);
    } else {
      // for title
      this._ToolbarService._ToolBarTitle.next("Generate Certificate");
      // for btn
      this._ToolbarService._isBackBtnShow.next(false);
    }
  }

  onChooseCertificate() {
    const dialog = this._matDialog.open(ChooseCertificateDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      disableClose: false,
      width: '794px',
      data: {
        certificates: this.allCertificate.length ? this.allCertificate : []
      }
    })

    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.form.get('selectedTempateId').setValue(res.id);
        this.selectedTemplate = res;
      } else {
        if (!this.selectedTemplate)
          this.form.get('certificateType').setValue('withEvent')
      }
    })

  }

  getAllCertificateList(attachType) {
    return new Promise((resolve, reject) => {
      this._CertificateTemplatesService.onGetAllCertificateList(attachType).then((res: any) => {
        if (res.status == 200) {
          this.allCertificate = res.data;
          this.cdr.detectChanges();
          resolve(res);
        } else {
          this.allCertificate = [];
          this._MatSnackBar.open(res.message, 'OKAY', { duration: 3000 });
          resolve(res);
        }
      }).catch(reject);
    });
  }



  onGenerateCertificate() {


    this.selectedGroup.setValue('all');
    this.dataSource = [];
    this.selectedEvent = null;
    this.form.get('selectedEvent').setValue('')
    this.showDetails = false;

    if (this.form.get('certificateType').value === 'withoutEvent') {
      this.getContactMembers()
    } else {
      // this.isTemplateChoose = true;
      this.filterData()
    }

    this.isTemplateChoose = true;

  }

  getContactMembers() {
    this._CommonService.getAllContacts(this.filter).then((res: any) => {
      if (res.status == 200) {
        this.dataSource = new MatTableDataSource(res.data.contactList);
        this.maxAvailableRecordsInTable = res.data.totalRecords;
        this.cdr.detectChanges();
      } else {
        this.dataSource = new MatTableDataSource([]);
        this.maxAvailableRecordsInTable = 0;
      }
    })
  }

  goBack() {
    this.isTemplateChoose = false;
    this.removeSelectedUsers();
  }
  clearSearch() {
    this.filtered.search = '';

    if (this.isGetDataFromEventId) {
      this.filterData();
    } else {
      this.onGroupSelect(this.filtered?.id)
    }
    // this.filterData();
  }

  filterData() {
    this._GenerateCertificateService.getUserList(this.filtered).then((res: any) => {
      if (res.status == 200) {
        this.dataSource = new MatTableDataSource(this.addNewKey(res.data.userList));
        this.maxAvailableRecordsInTable = res.data.totalRecords;
        this.cdr.detectChanges();
      } else {
        this.dataSource = new MatTableDataSource([]);
        this.maxAvailableRecordsInTable = 0;
      }
    })
  }

  addNewKey(array) {
    array.forEach((obj) => {
      obj['checked'] = false;
    });
    return array;
  }

  /**
   * Toggle selected contact by id
   *
   * @param id
   */
  selectionChanged(user): void {
    // debugger;
    // First, check if we already have that contact as selected...
    if (this.selectedUsers.length > 0) {
      const index = this.selectedUsers.indexOf(user);

      if (index !== -1) {
        this.selectedUsers.splice(index, 1);

        // Trigger the next event
        this.checkBoxStuff(user);
        this.selectAllCheckBoxState();
        this.storeInlocalStorage(this.selectedUsers);
        console.log('this.selectedUsers SelectionRemoved :', this.selectedUsers);


        // Return
        return;
      }
    }
    // If we don't have it, push as selected
    this.selectedUsers.push(user);

    this.checkBoxStuff(user);
    this.selectAllCheckBoxState();

    this.storeInlocalStorage(this.selectedUsers)

    console.log('this.selectedUsers SelectionADDED :', this.selectedUsers);

  }


  checkBoxStuff(user) {
    this.checkboxes[user] = this.selectedUsers.includes(user);
  }



  /** 
   * Maintains State of Select All CheckBox
   */

  selectAllCheckBoxState() {
    this.hasSelectedUsers = this.userList.length == this.selectedUsers.length
    this.isIndeterminate = (this.selectedUsers.length !== this.userList.length && this.selectedUsers.length > 0);
  }


  storeInlocalStorage(selectedUsers) {
    this.removeSelectedUsers();
    localStorage.setItem('selectedAttendees', JSON.stringify(selectedUsers));
  }

  generateCertificate(type) {

    console.log("hello in the generate certificate ", this.selectedEvent);

    const payload = {
      eventId: this.selectedEvent?.id ?? 0,
      id: this.form.get('selectedTempateId').value,
      isShow: 1, // default
      userIdsArray: type == 1 ? this.getSelectedUser() : [],
      isDefault: this.selectedEvent?.id ? 0 : 1,// if user select contact then send 1 or 0
      isContactGroup: !this.isGetDataFromEventId ? 1 : 0,   // if select group send 1
      contactGroupId: this.isSelectedGroupId
    }


    console.log("this.isSelectedGroupId", payload);

    this._CommonService.onGenerateCertificate(payload).then((res: any) => {
      if (res.status == 200) {
        this.showSuccessDialog();
      } else {
        this._MatSnackBar.open(res.message, 'OKAY', { duration: 4000 })
      }
    })

  }


  showSuccessDialog() {
    const dialog = this._matDialog.open(SuccessDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      width: '464px',
      autoFocus: false,
      data: {
        image: 'https://event-project-gts.s3.amazonaws.com/ceritificate/layout/backgroundImage/background_1711626310550.png',
        imageWidthSize: '164px',
        message: this.isWithoutEvent ? `Certiifcated have been successfully generated for <b>${this.selectedUsers.length}</b> contacts` : `Certiifcated have been successfully generated for <b>${this.selectedUsers.length}</b> attendees`,
        buttonText: 'View'

      }
    })

    dialog.afterClosed().subscribe((res) => {
      this._router.navigate(['/certificate/certificates'], { queryParams: { filterFor: this.selectedEvent?.id } })
    })
  }



  onGroupSelect(id) {
    this.isGetDataFromEventId = false;
    this.filtered["id"] = Number(id);
    delete this.filtered['eventId'];
    this.isSelectedGroupId = Number(id);

    this._groupsService.getGroupContactlist(this.filtered).then((res: any) => {
      if (res.contactList?.length) {
        if (this.form.get('certificateType').value === 'withoutEvent') {
          this.dataSource = new MatTableDataSource(res.contactList);
        } else {
          this.dataSource = new MatTableDataSource(this.addNewKey(res.contactList));
        }
        this.maxAvailableRecordsInTable = res.totalRecords;
        this.cdr.detectChanges();
      } else {
        this.dataSource = new MatTableDataSource([]);
        this.maxAvailableRecordsInTable = 0;
      }
    })
  }


  isAllSelected(): boolean {
    const data = this.dataSource?.filteredData || [];
    return data.length > 0 && data.every(row => this.checkboxes[row.id]);
  }

  toggleSelectAll(checked: boolean): void {
    const data = this.dataSource?.filteredData || [];
    data.forEach(row => {
        this.checkboxes[row.id] = checked;
        this.selectionChanged(row.id);
    });
}

}